import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { StaticQuery, graphql } from "gatsby";

const Image = (props) => (
  <StaticQuery
    query={graphql`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              extension
              publicURL
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  placeholder: DOMINANT_COLOR
                )
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const image = data.images.edges.find((n) =>
        n.node.relativePath.includes(props.filename)
      );
      if (!image) {
        return null;
      }
      if (!image.node.childImageSharp && image.node.extension === "svg") {
        return <img src={image.node.publicURL} alt={props.alt} {...props} />;
      }
      return (
        <GatsbyImage
          image={image.node.childImageSharp.gatsbyImageData}
          className="img-fluid"
          {...props}
        />
      );
    }}
  />
);

Image.propTypes = {
  filename: PropTypes.string.isRequired,
  alt: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.any,
  layout: PropTypes.string,
};

export default Image;
